import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "./AlertPop.module.scss";
import { CloseIcon } from "Assets/icons";
import { Formik } from "formik";
import { RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import updateEmailSchema from "./updateEmail.schema";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { successMessageToast } from "helpers/common";
import { useSendUpdateEmailOtpMutation, useVerifyEmailOtpMutation } from "store/services/auth";

const UpdateEmailPop = ({ confirmation, setConfirmation, }) => {

  const [sendEmailOtp, { isLoading: sendOtpLoading }] = useSendUpdateEmailOtpMutation();
  const [verifyEmail, { isLoading: verifyEmailLoading }] = useVerifyEmailOtpMutation();

  const hideHandler = () => {
    setConfirmation(false);
  };

  const handleSubmit = async (values, { setFieldValue }) => {
    try {
      if (!values.otp) {
        const result = await sendEmailOtp({ email: values['email']?.toLowerCase() });
        if (result?.error) return;
        setFieldValue("showOtpInput", true);
        successMessageToast(result?.data?.message);
        return;
      };
      const result = await verifyEmail({ email: values['email'], otp: values['otp'] });
      if (result?.error) return;
      hideHandler();
      successMessageToast(result?.data?.message);

    } catch (error) { console.log("Error sending update email otp.", error) };
  };

  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.ConfirmationPop} transparentModal common-alert-modal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <Button
            onClick={hideHandler}
            className="border-0 p-0 position-absolute"
            variant="transparent"
            style={{ right: 10, top: 0 }}
          >
            <CloseIcon />
          </Button>
          <div>
            <h6 className="m-0 fw-bold themeBlue">Change Email</h6>
          </div>
          <Formik
            initialValues={{ email: "" }}
            validationSchema={updateEmailSchema}
            onSubmit={handleSubmit}
            enableReinitialize
          >
            {({
              handleSubmit,
              values, errors
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="mt-2">
                  <Col lg="12" className="my-2">
                    <label
                      htmlFor=""
                      className="form-label themeBlue fw-bold mb-0 d-flex"
                    >
                      Email
                      <RequiredFieldAstrick />
                    </label>
                    <AppInputField
                      name="email"
                      type="text"
                      placeholder="Enter Email"
                      className={`${styles.formControl} form-control`}
                    />
                  </Col>
                  {
                    values?.showOtpInput && <Col lg="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0 d-flex"
                      >
                        OTP
                        <RequiredFieldAstrick />
                      </label>
                      <AppInputField
                        name="otp"
                        type="text"
                        placeholder="Enter OTP"
                        className={`${styles.formControl} form-control`}
                        maxLength={20}
                      />
                    </Col>
                  }
                  <Col className="my-2" lg="12">

                    <Button
                      type="submit"
                      className="d-flex align-items-center justify-content-center commonBtn"
                      disabled={sendOtpLoading || verifyEmailLoading}
                    >
                      {sendOtpLoading || verifyEmailLoading ? <LoadingIndicator inline /> : values?.showOtpInput ? "Submit" : "Send OTP"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpdateEmailPop;
